export function adaptNotification(item) {
    const metadata = item.metadata || {};

    let actionButton = null;
    if (metadata.linkUrl) {
        actionButton = {
            label: metadata.linkMessage || 'Abrir',
            action: 'navigate',
            url: metadata.linkUrl,
            icon: 'ExternalLink',
            variant: 'outline',
        };
    } else if (item.type === 'DOCUMENT_SIGNED') {
        actionButton = {
            label: metadata.linkMessage || 'Ver meus contratos',
            action: 'navigate',
            url: '/contract-dashboard',
            icon: 'FolderOpen',
            variant: 'primary',
        };
    }

    return {
        id: item.notification_id,
        title: item.title,
        message: item.message,
        type: item.type,
        timestamp: item.createdAt,
        isRead: item.read,

        metadata,

        actionButton,
    };
}